import i18n from '@/locales'

export default {
  created () {
    const step = ['init', 'open', 'submit', 'print', 'sent', 'recv', 'cancel', 'revoke', 'revoke_fail']
    this.singleActions = [
      {
        label: i18n.t('scope.text_761'),
        action: (obj) => {
          this.createDialog('InvoicePrintDialog', {
            data: [obj],
            onManager: this.onManager,
          })
        },
        meta: (obj) => {
          return {
            validate: obj.status === 'submit',
          }
        },
      },
      {
        label: i18n.t('scope.text_575'),
        actions: obj => {
          return [
            {
              label: i18n.t('scope.text_762'),
              action: (obj) => {
                this.createDialog('InvoicePostDialog', {
                  data: [obj],
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: obj.status === 'print',
                }
              },
            },
            {
              label: i18n.t('scope.text_760'),
              action: (obj) => {
                this.createDialog('InvoiceVoidDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: step.indexOf(obj.status) > 2 && obj.status !== 'cancel',
                }
              },
            },
            {
              label: i18n.t('scope.text_456'),
              action: (obj) => {
                this.createDialog('InvoiceCancleDialog', {
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: step.indexOf(obj.status) < 3 && obj.status !== 'cancel',
                }
              },
            },
          ]
        },
      },
    ]
  },
}
